<div class="change-pwd-container">
  <div class="change-pwd-title">{{'account_settings.change_pwd_title' | translate}}</div>
  <form class="change-pwd-form" autocomplete="off" novalidate (ngSubmit)="onSubmit()" [formGroup]="userPasswordForm">
    <div class="old-password-field">
      <div class="d-flex flex-column first-form-col">
        <label class="input-label" for="oldPassword">{{'account_settings.form_label.old_pwd' | translate}}</label>
        <input  autocomplete="off"
                formControlName="oldPassword"
                name="oldPassword"
                type="password"
                [(ngModel)]="userPasswordData.oldPassword"
                class="form-control"
                [ngClass]="{'error-input': oldPassword.invalid && (oldPassword.dirty || oldPassword.touched)}" />
      </div>
      <div class="d-flex flex-column second-form-col"></div>
    </div>
    <div class="new-password-field">
      <div class="d-flex flex-column first-form-col">
        <label class="input-label" for="newPassword">{{'account_settings.form_label.new_pwd' | translate}}</label>
        <input formControlName="newPassword"
                name="newPassword"
                type="password"
                [(ngModel)]="userPasswordData.newPassWord"
                class="form-control"
                [ngClass]="{'error-input': !isValidNewPwd}" />
      </div>
      <div class="d-flex flex-column second-form-col">
        <label class="input-label" for="repeatNewPassword">{{'account_settings.form_label.repeat_new_pwd' | translate}}</label>
        <input formControlName="repeatNewPassword"
                name="repeatNewPassword"
                type="password"
                [(ngModel)]="userPasswordData.repeatNewPassword"
                class="form-control"
                [ngClass]="{'error-input': !isValidNewPwd}" />
      </div>
    </div>
  </form>
</div>
<achoo-popup #ChangePwdNotificationPopup
             [isNotification]="true"
             modelTitle="{{popupTitle}}">
  <span>{{msgString}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/account-setting/user-settings/change-pwd/change-pwd.component.html